







import Vue from 'vue';
import mapboxgl, { MapboxOptions, MapMouseEvent } from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

import config from '@/config';

mapboxgl.accessToken = config.VUE_APP_MAPBOX_ACCESS_TOKEN;

const maps = new Map();
const mapNavigationControl = new mapboxgl.NavigationControl();

type navPosition = 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';

export default Vue.extend( {
	props: {
		navPosition: {
			type: String,
			default: 'top-left'
		},
		moveEnabled: {
			type: Boolean,
			default: true
		},
		initialLat: {
			type: Number,
			default: undefined
		},
		initialLon: {
			type: Number,
			default: undefined
		},
		initialZoom: {
			type: Number,
			default: undefined
		}
	},
	watch: {
		moveEnabled() {
			this.updateMoveEnabled();
		}
	},
	mounted() {
		const options: MapboxOptions = {
			container: this.$refs.map as HTMLElement,
			style: config.VUE_APP_MAPBOX_STYLE
		};
		if ( this.initialLat !== undefined && this.initialLon !== undefined ) {
			options.center = [ this.initialLon, this.initialLat ];
		}
		if ( this.initialZoom !== undefined ) {
			options.zoom = this.initialZoom;
		}
		const map = new mapboxgl.Map( options );
		maps.set( this, map );
		map.on( 'moveend', ( evt: MapMouseEvent ) => {
			this.$emit( 'moveEnd', evt );
		} );
		map.on( 'load', () => {
			this.$emit( 'load' );
		} );
		map.on( 'style.load', () => {
			this.$emit( 'styleLoad' );
		} );
		this.$emit( 'init', map );
		this.updateMoveEnabled();
	},
	destroyed() {
		if ( maps.has( this ) ) {
			maps.get( this ).remove();
			maps.delete( this );
		}
		this.$emit( 'release' );
	},
	methods: {
		updateMoveEnabled() {
			const map: mapboxgl.Map | undefined = this.getMap();
			if ( map ) {
				if ( this.moveEnabled ) {
					map.dragPan.enable();
					map.boxZoom.enable();
					map.scrollZoom.enable();
					if ( !map.hasControl( mapNavigationControl ) ) {
						map.addControl( mapNavigationControl, this.navPosition as navPosition );
					}
				} else {
					map.dragPan.disable();
					map.boxZoom.disable();
					map.scrollZoom.disable();
					if ( map.hasControl( mapNavigationControl ) ) {
						map.removeControl( mapNavigationControl );
					}
				}
			}
		},
		getMap(): mapboxgl.Map | undefined {
			return maps ? maps.get( this ) : undefined;
		},
		panTo( lng: number, lat: number ) {
			const lngLat = new mapboxgl.LngLat( lng, lat );
			const map: mapboxgl.Map = maps.get( this );
			map.panTo( lngLat, { duration: 500 } );
		}
	}
} );
